import Button from '@mui/material/Button';
import {
  Link as RouterLink,
  useMatch,
  useResolvedPath,
} from 'react-router-dom';

export type ISubNavLinkProps = {
  to: string;
  title: string;
};

const styles = {
  '&.MuiButton-root': {
    fontWeight: '700',
    color: 'white',
    paddingX: 1,
  },
  '&.MuiButton-contained': {
    backgroundColor: '#0d3c61',
  },
};

export function SubNavLink({ title, to }: ISubNavLinkProps) {
  const resolved = useResolvedPath(to);
  const match = useMatch({ path: resolved.pathname, end: false });
  return (
    <Button
      size="small"
      sx={{ ...styles }}
      variant={match ? 'contained' : 'text'}
      to={to}
      component={RouterLink}
    >
      {title}
    </Button>
  );
}
